import classNames from 'classnames';
import { motion } from 'framer-motion';
import Link from 'next/link';
import React from 'react';
import { useRecoilValue } from 'recoil';
import Layout from '~/layouts/ThemeLayout/ThemeLayout';
import storeConfigAtom from '~/services/store-config/store-config.atom';

type LayoutLaunchProps = {
    children?: React.ReactNode;
    suffix?: React.ReactNode;
};

const HeaderLaunch = ({ suffix }: { suffix?: React.ReactNode }) => {
    const storeConfig = useRecoilValue(storeConfigAtom.store);

    return (
        <motion.div
            initial={{ backgroundColor: '#000000' }}
            animate={{
                backgroundColor: '#000000'
            }}
            className={classNames(
                `sticky top-0 shadow-sm h-[60px] flex justify-between items-center z-20 px-2 md:px-6`
            )}
        >
            <Link href="/sneaker-release">
                {storeConfig?.frontend_config_logo && (
                    <img
                        src={storeConfig?.frontend_config_logo || ''}
                        alt="Logo"
                        className="h-full object-contain object-left"
                        width={150}
                    />
                )}
            </Link>
            {suffix}
        </motion.div>
    );
};

const LayoutLaunch = ({ children, suffix }: LayoutLaunchProps) => {
    return (
        <Layout renderHeader={<HeaderLaunch suffix={suffix} />} footer={null}>
            {children}
        </Layout>
    );
};

export default LayoutLaunch;
